export default {
    pageName: 'ประวัติการลงเวลา',
    tab: {
        attendance: ' การลงเวลา ',
        quota: 'สิทธิคงเหลือ'
    },
    date: {
        title: 'วันที่'
    },
    header: {
        detail: 'รายละเอียด',
        status: 'สถานะ'
    }
}
